import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import dayjs from "dayjs";
import useApi from "../../../core/customhook/useApi";
import { useNavigate } from "react-router";

interface EventType {
  start: string;
  title: string;
  holiday_category: "MH" | "RH";
}

const HolidayCalendar: React.FC = () => {
  const [holidayEvents, setHolidayEvents] = useState<EventType[]>([]);
  const navigate = useNavigate()
  const {
    data: holidayCalendarData,
    loading: holidayCalendarLoading,
    error: holidayCalendarError,
    callApi: getHoliday,
  } = useApi("/api/holiday-list", {
    method: "POST",
    autoCall: false,
  });

  useEffect(() => {
    getHoliday({ category: "" }); // trigger API call
  }, []);

  useEffect(() => {
    if (holidayCalendarData?.data) {
      const holidays: EventType[] = holidayCalendarData.data.map(
        (item: any) => ({
          start: item.holiday_date,
          title: item.holiday,
          holiday_category: item.holiday_category,
        }),
      );
      setHolidayEvents(holidays);
    }
  }, [holidayCalendarData]);

   const handleDateClick = (arg: { date: Date }) => {
    const selectedDate = dayjs(arg.date).format("YYYY-MM-DD");
    navigate(`/leave-application?date=${selectedDate}`);
  };


  return (
    <div className="card border-0" id="leave-calendar">
      <div className="card-body p-2">
        <div className="fc-wrapper" id="dashboardcalendar">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            headerToolbar={{
              start: "today",
              center: "title",
              end: "prev,next",
            }}
            height={400}
            dateClick={handleDateClick}
            dayCellContent={({ date }) => {
              const formattedDate = dayjs(date).format("YYYY-MM-DD");

              const holiday = holidayEvents.find(
                (e) => e.start === formattedDate,
              );

              let dotColor: string | null = null;
              if (holiday) {
                dotColor =
                  holiday.holiday_category === "MH" ? "#dc3545" : "#007bff";
              }

              return (
                <div style={{ position: "relative", textAlign: "center" }}>
                  <div style={{ fontSize: "0.75rem" }}>{date.getDate()}</div>

                  {holiday && (
                    <div style={{ fontSize: "8px", marginTop: "2px" }}>
                      {holiday.title}
                    </div>
                  )}

                  {dotColor && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "3px",
                      }}
                    >
                      <span
                        title={
                          holiday?.holiday_category === "MH"
                            ? "Mandatory Holiday"
                            : "Restricted Holiday"
                        }
                        style={{
                          width: 8,
                          height: 8,
                          backgroundColor: dotColor,
                          borderRadius: "50%",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          />
        </div>

        {/* Legend */}
        <div className="pt-2">
          <div className="card border-0">
            <div className="card-body py-2 px-3">
              <ul
                className="list-unstyled mb-2 d-flex gap-4 flex-wrap align-items-center"
                style={{ fontSize: "0.75rem" }}
              >
                {[
                  { color: "#dc3545", label: "Mandatory Holiday (MH)" },
                  { color: "#007bff", label: "Restricted Holiday (RH)" },
                ].map(({ color, label }) => (
                  <li key={label} className="d-flex align-items-center">
                    <span
                      style={{
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        backgroundColor: color,
                        borderRadius: "50%",
                        marginRight: "6px",
                      }}
                    ></span>
                    {label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayCalendar;
